import { ObjectContainerClientT, PoiContainerCollectionItemT, ObjectTypeClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { Fragment, ReactElement, useContext } from 'react';
import { AppContext } from '../../../../state/app.state';
import { isMobile } from '../../../../utils/app.helper';
import PoiMarkerBox from '../../marker/PoiMarkerBox/PoiMarkerBox';
import MappingFacts from '../MappingFacts/MappingFacts';
import PoiMappingBox from '../PoiMappingBox/PoiMappingBox';

const SVGBoxes: React.FC = (): ReactElement => {

    const { state } = useContext(AppContext);

    const getObjectFromEntityId = (entityId: number): ObjectContainerClientT | undefined => {
        return state?.objects?.find((obj) => {
            return obj.id === entityId;
        });
    };
    const getPoiFromEntityId = (entityId: number): PoiContainerCollectionItemT | undefined => {
        return state?.project?.poiContainers?.find((obj) => {
            return obj.id === entityId;
        });
    };

    const getObjectTypeFromId = (objectTypeId?: number): ObjectTypeClientT | undefined => {
        if (!objectTypeId) return undefined;

        const ot = state?.project?.objectTypes.find((oT) => {
            return oT.id === objectTypeId;
        });

        return ot;
    };


    return useObserver(() => (
        <>
            {state?.currentViewMappingObjects &&
            state?.currentViewMappingObjects.filter(({ mappingEntityId }) => {
                return state.isCurrentPreviewObject(mappingEntityId) && !isMobile();
            })
                .map((obj) => {
                    const previewObject = obj.mappingEntityId && getObjectFromEntityId(obj.mappingEntityId);

                    return <Fragment key={obj.id}>
                        {previewObject && <MappingFacts
                            key={previewObject.mappingEntityId?.toString()}
                            objectId={previewObject.mappingEntityId}
                            previewObject={previewObject}
                            previewObjectType={previewObject && getObjectTypeFromId(previewObject.objectTypeId)}
                            previewObjectMapping={obj}
                        ></MappingFacts>}
                    </Fragment>;
                })}
            {state?.currentView?.mappings.poiContainers
                .filter(({ mappingEntityId }) => state.isCurrentPreviewObject(mappingEntityId) && !isMobile())
                .map(poiMapping => {
                    const previewPoi = poiMapping.mappingEntityId && getPoiFromEntityId(poiMapping.mappingEntityId);

                    return <Fragment key={poiMapping.id}>
                        {previewPoi && <PoiMappingBox
                            previewPoi={previewPoi}
                            poiMapping={poiMapping}
                        />}
                    </Fragment>;
                })}
            {state?.currentView?.markers.poiContainers
                .filter(({ mappingEntityId }) => state.isCurrentPreviewObject(mappingEntityId) && !isMobile())
                .map(poiMarker => {
                    const previewPoi = poiMarker.mappingEntityId && getPoiFromEntityId(poiMarker.mappingEntityId);

                    return <Fragment key={poiMarker.id}>
                        {previewPoi && <PoiMarkerBox
                            previewPoi={previewPoi}
                            poiMarker={poiMarker}
                        />}
                    </Fragment>;
                })}</>
    ));
};


export default SVGBoxes;